<template>
  <div class="categoryDetails">
    <edit-category-trigger
      v-if="!isMobile() && showEditTrigger"
      :categoryId="categoryId"
      class="editIcon subcategory"
    />
    <!-- FIXME - Add links here when not in emit mode -->
    <i @click="emitCategoryClick">
      {{ getCategoryName(categoryId) }}
    </i>
  </div>
</template>

<script>
import EditCategoryTrigger from "./EditCategoryTrigger.vue";

import categoryUtil from "../categoryUtil.js";
import eventHub from "../eventHub.js";
import util from "../util.js";

export default {
  name: "subcategory-details-block",
  mixins: [categoryUtil.getMixin(), util.getMobileMixin()],
  components: {
    "edit-category-trigger": EditCategoryTrigger,
  },
  props: {
    categoryId: String,
    showEditTrigger: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitCategoryClick() {
      eventHub.$emit("category-details-block-clicked", { id: this.categoryId });
    },
  },
};
</script>

<style scoped>
/* FIXME - Standardize styling please! */
.categoryDetails {
  font-size: 0.875rem;
  cursor: pointer;
}

.editIcon.subcategory.material-icons.action-icon {
  font-size: 12px;
  position: relative;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// SubcategoryDetailsBlock.vue?23f21196